
const pageScrollTo = (tar, e) => {

	// var base = location.protocol + '//' + location.hostname;

	// if(location.pathname != '/' && !location.pathname)
	// base +=  '/' + location.pathname;

	// if(!location.pathname || location.pathname == '/'){
	// 	base += '/';
	// }

	//var tar = tar.replace(base, '');

	// var str = tar.slice(0, 1);

	//if(str == '#'){

		if(e)
		e.preventDefault();

		tar = tar.replace('#', '');

		if($('[data-id="' + tar + '"]').length){
			var pos = tar == '#header' ? 0 : $('[data-id="'+tar+'"]').offset().top - 80;
			$('html,body').stop().animate({ scrollTop: pos }, 0, 'easeOutExpo');
		}

	//}

}


const takeOverParameters = ()=>{
		
	const domain = window.location.hostname;
	const parameters = location.search.substr(1);
	const params = findGetParameters();
	
	if(parameters){

		$('a, area').each((i, elem)=>{

			const href = $(elem).attr('href');

			if( href.indexOf(domain) > -1 || href.indexOf('http') == -1 ){

				let tmpParams = href.split('?');

				if(tmpParams.length > 1){
					
					let paramStr = '';

					tmpParams = tmpParams[1].split("&")
					//console.log(tmpParams)

					tmpParams.forEach(function (item) {
			
						let ary = item.split("=");
						
						console.log(ary[0])
						if(!params[ary[0]]){
							console.log(ary[0])
							paramStr += '&' + item;
							console.log(paramStr)
						}
					});

					$(elem).attr('href', tmpParams[0] + '?' + parameters + paramStr);

				} else {
					$(elem).attr('href', href + '?' + parameters);
				}

				
			}


		});

	}

}


const findGetParameters = ()=>{
	
	let tmp = {};
	// console.log(location.search
	// 	.substr(1)
	// 	.split("&"))
	location.search
			.substr(1)
			.split("&")
			.forEach(function (item) {
				let ary = item.split("=");
				tmp[ary[0]] = ary[1];
			});
	return tmp;
}



(()=>{

	const $doc = $(document);
	const $win = $(window);
	const $siteHeader = $('.site-header');
	const $sticker = $('.sticky-button');
	let isHome = false;

	if($('.home-page').length){
		isHome = true;
	}

	let _qg = {};


	_qg.ua = (function(){
		
		var _ua = navigator.userAgent.toLowerCase();
		var _o = {
			ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
			ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
			ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
			IE9: navigator.appVersion.toLowerCase().indexOf("msie 9.") != -1,
			IE10 : navigator.userAgent.match(/Trident\/[6]/i),
			IE11: navigator.userAgent.match(/Trident\/7\./),
			IE:document.uniqueID,
			Firefox:window.sidebar,
			Opera:window.opera,
			chrome: _ua.indexOf('chrome') > -1,
			//Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
			mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
			iphone:/iphone|ipod/i.test(_ua),
			android:/android/.test(_ua),
			ipad:/ipad/.test(_ua),
			tablet:undefined,
			smartphone:undefined
		}
		_o.tablet = _o.ipad;
		if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}				
		_o.smartphone = _o.iphone || _o.android ? true : false;
		
		var v = [];
		if (/iP(hone|od|ad)/.test(navigator.platform)) {v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);}
		var vAry = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
		_o.iosV = vAry[0] ? vAry[0] : '';
		
		
		return _o;
	})();

	

	$(window).on('scroll', (e)=>{
		let st = $(e.currentTarget).scrollTop();
		
		if(st > 60) {
			$siteHeader.addClass('minimized');
		} else {
			$siteHeader.removeClass('minimized');
		}

		if(isHome){
			if(st > 400) {
				$sticker.addClass('visible');
			} else {
				$sticker.removeClass('visible');
			}
		}

	});

	
	// Function to get a cookie
	function getCookie(name) {
		var cookieArr = document.cookie.split("; ");
		for(var i = 0; i < cookieArr.length; i++) {
				var cookiePair = cookieArr[i].split("=");
				if(name == cookiePair[0]) {
						return decodeURIComponent(cookiePair[1]);
				}
		}
		return null;
	}

	// Function to set a cookie
	function setCookie(name, value, exp) {
		var date = new Date();
		date.setTime(date.getTime() + (exp*60*1000));
		var expires = "; expires=" + date.toUTCString();
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}

	// function to compare two arrays and check if they have same values
	// if one array has value that the other array doesn't have, return false
	function compareArray(a, b) {
		if (a.length != b.length) {
			return false;
		}
		for (var i = 0; i < a.length; i++) {
			if (b.indexOf(a[i]) == -1) {
				return false;
			}
		}
		return true;
	}


	const visiedForm = getCookie('visitedform');
	let makers_option = $('.house-builders-list .mwform-checkbox-field');

	if(visiedForm) {
		//shuffle the order of makers_option
		const cookie_value = visiedForm;
		const cookie_value_ary = cookie_value.split(',');
		cookie_value_ary.reverse();

		const default_option_ary = [];
		makers_option.each((i, el)=>{
			const value = $(el).find('input[name="house_builders[data][]"]').val();
			default_option_ary.push(value);
		});
		
		if(compareArray(cookie_value_ary, default_option_ary) == false) return false; 



		for (let i = 0; i < cookie_value_ary.length; i++) {
			const value = cookie_value_ary[i];
			if(!default_option_ary.includes(value)){
				return false;
			}
		}

		// sort makers_option by cookie_value_ary
		for (let i = 0; i < cookie_value_ary.length; i++) {
			const value = cookie_value_ary[i];
			makers_option.each((i, el)=>{
				const input = $(el).find('input[name="house_builders[data][]"]');
				if(input.val() == value){
					$('.house-builders-list').prepend(el);
				}
			});
		}
		
		//makers_option.remove();

	}	else {

		for (let i = makers_option.length - 1; i >= 0; i--) {
			let rand = Math.floor(Math.random() * (i + 1));
			[makers_option[i], makers_option[rand]] = [makers_option[rand], makers_option[i]]
		}
		makers_option.remove();

		$('.house-builders-list').prepend(makers_option);

		let value_ary = [];
		makers_option.each((i, el)=>{
			const value = $(el).find('input[name="house_builders[data][]"]').val();
			value_ary.push(value);
		});

		const value_str = value_ary.join(',');
		setCookie('visitedform', value_str, 30);

	}


	$('.process-list .process__title').matchHeight();
	$('.process-list .process__description').matchHeight();
	$('.points .points__description').matchHeight();

	$('.toggle-nav-button').on('click', ()=>{
		menu.toggle();
	});

	$('body').on('click', (e)=>{
		if(menu.menuOpen){
			if(!$(e.target).closest('.site-nav').length && !$(e.target).closest('.toggle-nav-button').length) {
				if(menu.menuOpen)
				menu.close();
			}
		}
	});

	if(location.hash){
		pageScrollTo(location.hash);
	}	

	$('.cases .case__title').matchHeight();

	if($('.hero__image').length > 1){
		console.log('hoge')
		new Swiper('.swiper-container', {
			effect: 'fade',		
			speed: 1000,
			autoplay: {
				delay: 5000,
			}
		});	
	}

	if($('.multiple-slides').length){
		var multiSwiper = new Swiper('.swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 20,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
			breakpoints: {
				// when window width is >= 480px
				600: {
					slidesPerView: 3,
					spaceBetween: 20
				},
				// when window width is >= 640px
				900: {
					slidesPerView: 4,
					spaceBetween: 20
				},
				1054: {
					slidesPerView: 4,
					spaceBetween: 20
				}				
			}						
		});	
	}
	
	$('.hero__images .hero__image-holder').addClass('visible');
	$('.hero-section .hero__image-caption *').addClass('visible');



	if(!$('#mw_wp_form_mw-wp-form-45 span.error').length){
		//$('[name="house_builders[data][]"]').prop('checked', true);
		//$('.privacy-note').addClass('visible');		
		//alert('test')
	} else {
		$('.error-notification').addClass('visible');
	}

	if($('form').length){
		$('[name="zipcode"]').attr('type', 'tel').attr('maxlength', '7');
		$('[name="zipcode"]').on('keydown', (e)=>{
			if(e.keyCode == '189') return false;
		})
	}

	if($('.catalog-request-page').length){
		$('form').addClass('h-adr');
		$('form input[type=checkbox]').each(function(e){
			$(this).wrap('<span class="checkbox-wrapper"></span>');
			if($(this).is(':checked')){
				$(this).parent().addClass('checked');
			}
		}).on('change', (e)=>{
			if($(e.currentTarget).is(':checked')){
				$(e.currentTarget).parent().addClass('checked');
			} else {
				$(e.currentTarget).parent().removeClass('checked');
			}
		});

		$('form [name="form_title"]').val($('.section__title:first').text());

		$('.custom-contents iframe').each((i, elem)=>{
			let src = $(elem).attr('src');
			if(src.indexOf('youtube') > -1){
				$(elem).wrap('<span class="video-container">');
				$(elem).wrap('<span class="video-wrapper">');
			}
		});
	}	

	$('img[usemap]').rwdImageMaps();

	if($('.catalog-request-page .custom-contents').length){
		$('.catalog-request-page .custom-contents').insertAfter('.form-wrapper .steps').addClass('visible');
	}

	takeOverParameters();



	$('.mw_wp_form form').on('submit', (e)=>{
		$('.mw_wp_form button[type="submit"]').attr('disabled', 'disabled');
		//$(e.currentTarget).preventDefault();
	})

	$('input[name="zipcode"], input[name="phone_number"]').attr('type', 'number');

	const invalidChars = [
		"-",
		"+",
		"e",
	];

	$('input[name="zipcode"], input[name="phone_number"]').on('keydown', (e)=>{
		if (invalidChars.includes(e.key)) {
			e.preventDefault();
		}
	})

	if(window.kanasumu.access_source){
		$('input[name="access_source"]').val(window.kanasumu.access_source);
		//$('input[name="access_source_title"]').val(window.kanasumu.access_source);
	}





})();


// const inputNumber = {
// 	prevValue: '',
// 	init: (tgt)=>{
// 		$(tgt).on('focus', (e)=>{
// 			this.prevValue = $(e.currentTarget).val();
// 		})
// 		$(tgt).on('input', (e)=>{
// 			// console.log($(e.currentTarget).val())
// 			// let value = $(e.currentTarget).val().replace(/-/g, '');
// 			// console.log(value)
// 			// $(e.currentTarget).val(value);
// 		})
// 	}
// }


const menu = {

	menuOpen: false,
	timer: null,
	// navScroll: null,

	// init(){
	// 	alert('test')
	// 	this.navScroll = new SimpleBar(document.getElementById('nav-scroll'), {
	// 		autoHide: false
	// 	});
	// },

	open(){

		this.menuOpen = true;

		$('.site-nav').show();
		$('.nav-menu-wrapper').show();

		if(this.timer) clearTimeout(this.timer);
		this.timer = setTimeout(
			()=>{
				$('.toggle-nav-button').addClass('opened');
				$('.site-nav').addClass('visible');
				$('.nav-menu-wrapper').addClass('visible');
				//$('.nav-menu-wrapper').removeClass('slideUp');
			}, 100);	

	},

	close(){

		this.menuOpen = false;
		
		$('.toggle-nav-button').removeClass('opened');
		$('.site-nav').removeClass('visible');
		$('.nav-menu-wrapper').removeClass('visible');
		// $('.nav-menu-wrapper').addClass('slideUp');
		
		if(this.timer) clearTimeout(this.timer);
		this.timer = setTimeout(
			()=>{
				$('.site-nav').hide();
				$('.nav-menu-wrapper').hide();
			}, 300);
		
	},

	toggle(){
		if(this.menuOpen){
			this.close();
		} else {
			this.open();
		}
	}	
	

}




